import type { Tour } from '../tour-types';

/**
 * The team screens: the agency's own team and the selected organization's. Both use the
 * same anchors, so one tour serves the two. Row steps point at the first row.
 */
export const settingsTeamTour: Tour = {
  key: 'settings.team',
  version: 1,
  routes: ['/settings/agency-team', '/settings/organization-team'],
  steps: [
    {
      anchor: 'team-heading',
      placement: 'bottom',
      title: 'Whose team',
      body: 'Organization Team lists the people of the account picked in the header. Agency Team, for agencies, lists your own staff, who work across your clients.',
    },
    {
      anchor: 'team-invite',
      placement: 'left',
      requires: 'team:manage',
      title: 'Invite a colleague',
      body: 'Send an invitation by email and choose their role. They join once they accept it.',
    },
    {
      anchor: 'team-role',
      title: 'Roles',
      body: 'A Member can see everything but change nothing. Admins and Owners can also change settings, invite people and manage billing.',
    },
    {
      anchor: 'team-status',
      title: 'Status',
      body: 'Invited means the invitation has not been accepted yet. Someone who is Blocked cannot sign in.',
    },
    {
      anchor: 'team-row-actions',
      placement: 'left',
      requires: 'team:manage',
      title: 'Manage a person',
      body: 'Block or unblock someone, resend an invitation, or remove them from the team.',
    },
  ],
};
